import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Moment from 'moment'
import {Link} from "react-router-dom";
import Img from 'react-image'


export default class MillenialsItem extends Component {
    getTitleName(){
        var name = this.props.item.title.toLowerCase().replace(/ +/g, "-")
        return name
    }
    render() {
        const {item} = this.props
        return (
            <Link to={`postagens/${item.id}/${this.getTitleName()}`}>
                <div className="row millennials-separator" >
                    <div className="col-12 col-lg-6 millenials-item-content">
                        {item.image_link? <Img src={item.image_link} alt={item.title}/>:<div className="video-container"><iframe width="400" height="300" src={item.video_link} frameBorder="0" allowFullScreen={true}/></div>}
                    </div>
                    <div className="col-12 col-lg-6 millenials-item-content description">
                        <span className="label"><time dateTime={item.date}>{Moment(item.date).format('DD/MM/YYYY')}</time></span>
                        <p className='title'>{item.title}</p>
                        <div dangerouslySetInnerHTML={{__html: item.description}} />
                    </div>
                </div>
            </Link>
        )
    }
}

MillenialsItem.propType = {
    title: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    thumb: PropTypes.string,
    video: PropTypes.string,
    link: PropTypes.string.isRequired
}


// WEBPACK FOOTER //
// ./src/components/milenials-item.js